<li class="nav-item pcoded-hasmenu" [routerLinkActive]="['active']">
  <a [routerLinkActive]="['active']" href="javascript:" class="nav-link" (click)="navCollapse($event)">
    @if (item.icon) {
      <span class="pcoded-micon">
        <i class="{{ item.icon }}"></i>
      </span>
    }
    <span class="pcoded-mtext">{{ item.title }} </span>
  </a>
  <ul class="pcoded-submenu" [routerLinkActive]="['active']">
    @for (item of item.children; track item) {
      @if (item.type === 'group') {
        <app-nav-group [item]="item"></app-nav-group>
      }
      @if (item.type === 'collapse') {
        <app-nav-collapse [item]="item"></app-nav-collapse>
      }
      @if (item.type === 'item') {
        <app-nav-item [item]="item"></app-nav-item>
      }
    }
  </ul>
</li>
